import { applyMiddleware, compose, createStore } from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import CryptoJS from "crypto-js";

const saveToLocalStorage = (state) => {
  const serializedUid = CryptoJS.AES.encrypt(
    JSON.stringify(state.authUser),
    "my-secret-key"
  ).toString();
  localStorage.setItem("auth", serializedUid);
  localStorage.setItem("cart", JSON.stringify(state.cart));
};

const checkLocalStorage = () => {
  const serializedUid = localStorage.getItem("auth");
  const storedCart = localStorage.getItem("cart");

  return {
    authUser: serializedUid
      ? JSON.parse(
          CryptoJS.AES.decrypt(serializedUid, "my-secret-key").toString(
            CryptoJS.enc.Utf8
          )
        )
      : undefined,
    cart: storedCart ? JSON.parse(storedCart) : [],
  };
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  checkLocalStorage(),
  composeEnhancers(applyMiddleware(thunk))
);

store.subscribe(() => saveToLocalStorage(store.getState()));

export default store;
